const discrepancyStandardization = {
  dashboard: "Panel",
  configuration: "Configuración",
  discrepancy: "Discrepancia",
  discrepancy_configuration: "Configuración De Discrepancia",
  invoice_delivery_note: "Factura <> Albarán de entrega",
  invoice_delivery_note_description:
    "Compara las líneas de factura basadas en PO con las líneas del albarán de entrega a las que están vinculadas",
  invoice_purchase_order: "Factura <> Orden de compra",
  invoice_purchase_order_description:
    "Compara las líneas de factura basadas en PO con las líneas de la orden de compra a las que están vinculadas",
  match_unit_price: "Coincidir precio unitario",
  match_unit_price_description_delivery_note:
    "Marcar cuando el precio de la factura difiere del precio del albarán de entrega",
  match_unit_price_description_purchase_order:
    "Marcar cuando el precio de la factura difiere del precio de la orden de compra",
  unit_price_tolerance: "Tolerancia de precio unitario",
  unit_price_tolerance_description:
    "Importe absoluto, p. ej. 0.50 permite una diferencia de hasta 0.50",
  match_quantity: "Coincidir cantidad",
  match_quantity_description_delivery_note:
    "Marcar cuando la cantidad facturada supera lo que queda en el albarán de entrega (después de otras facturas)",
  match_quantity_description_purchase_order:
    "Marcar cuando la cantidad facturada supera lo que queda en la orden de compra (después de otras facturas)",
  quantity_tolerance: "Tolerancia de cantidad",
  quantity_tolerance_description:
    "Número absoluto de unidades permitidas por encima",
  detect_missing_delivery_note_reference:
    "Detectar referencia de albarán de entrega faltante",
  detect_missing_delivery_note_reference_description:
    "Marcar las líneas de factura que no se pudieron vincular a una línea del albarán de entrega",
  detect_missing_purchase_order_reference:
    "Detectar referencia de orden de compra faltante",
  detect_missing_purchase_order_reference_description:
    "Marcar las líneas de factura que no se pudieron vincular a una línea de PO",
  detect_description_mismatch: "Detectar diferencia de descripción",
  detect_description_mismatch_description:
    "Marcar cuando la descripción de la línea de factura difiere de la descripción de la línea del albarán (se ignoran mayúsculas y espacios extra)",
  invoice_goods_received_note: "Factura <> Nota de recepción de mercancías",
  invoice_goods_received_note_description:
    "Compara las líneas de factura basadas en PO con las líneas de la nota de recepción de mercancías a las que están vinculadas",
  match_unit_price_description_goods_received_note:
    "Marcar cuando el precio de la factura difiere del precio de la nota de recepción de mercancías",
  match_quantity_description_goods_received_note:
    "Marcar cuando la cantidad facturada supera lo que queda en la nota de recepción de mercancías (después de otras facturas)",
  detect_missing_goods_received_note_reference:
    "Detectar referencia de nota de recepción de mercancías faltante",
  detect_missing_goods_received_note_reference_description:
    "Marcar las líneas de factura que no se pudieron vincular a una línea de la nota de recepción de mercancías",
  detect_description_mismatch_description_goods_received_note:
    "Marcar cuando la descripción de la línea de factura difiere de la descripción de la línea de la nota de recepción de mercancías (se ignoran mayúsculas y espacios extra)",
  notifications: "Notificaciones",
  discrepancy_emails: "Correos de discrepancia",
  discrepancy_emails_description:
    "Se envían cuando se detecta una discrepancia",
  email_supplier_on_discrepancy: "Enviar correo al proveedor por discrepancia",
  email_user_on_discrepancy: "Enviar correo al usuario por discrepancia",
  daily_reminder_email: "Correo de recordatorio diario",
  daily_reminder_email_description: "Resumen diario de discrepancias abiertas",
  reset: "Restablecer",
  save: "Guardar",
  saved_successfully: "Configuración de discrepancia guardada correctamente",
  something_went_wrong: "Algo salió mal",
  field_required: "Este campo es obligatorio",
  value_cannot_be_negative: "El valor no puede ser menor que 0",
  value_cannot_exceed_max: "El valor no puede ser mayor que 5",
  "You have unsaved changes. Are you sure you want to leave?":
    "Tiene cambios sin guardar. ¿Seguro que desea salir?",
};

export default discrepancyStandardization;
